import { FC, forwardRef, HTMLProps, memo, PropsWithChildren } from 'react';
import { Link as LinkBase, LinkProps } from '@tempusfinance/common-ui';
import { Link as InternalLink } from 'react-router-dom';

import './Link.scss';

const Link = forwardRef<HTMLAnchorElement, PropsWithChildren<LinkProps>>((props, ref) => {
  const { className = '', disabled, href = '' } = props;

  const linkClassName = `nostra__link ${className}`;

  const internalLink = <InternalLink to={disabled ? '#' : href} />;

  return <LinkBase ref={ref} {...props} className={linkClassName} internalLink={internalLink} />;
});

export default memo(Link as FC<LinkProps & HTMLProps<HTMLAnchorElement>>);
